import { getStatusDotClass } from '@/modules/projects/status'
import type { StatementStatusKey } from '@/modules/projects/stores'
import { cn } from '@/utils'

interface ProcessProps {
  value: number
  max: number
  status?: StatementStatusKey
  title?: string
}

export const Progress = ({
  value,
  max,
  status = 'notStarted',
  title,
}: ProcessProps) => {
  if (value === 0) return null

  return (
    <div
      className={cn('h-full', getStatusDotClass(status))}
      style={{ width: `${(value / max) * 100}%` }}
      title={title}
    />
  )
}
